// Types of form field within the CustomBenchmark form
export const gradeFormValueTypes = {
  cutlineLabel: "CUTLINE_LABEL",
  cutlineValue: "CUTLINE_VALUE",
}

// Form input fields by grade, cutline, and season.
// These constants used to initialize the form for input.
export const customBenchmarkFormSettings = {
  numCutlines: 3,
  grades: [ // Values of grades, in a special format for Admin
    {label: "Kindergarten", value: 0, shortLabel: "k"},
    {label: "1st Grade", value: 1, shortLabel: "1st"},
    {label: "2nd Grade", value: 2, shortLabel: "2nd"},
    {label: "3rd Grade", value: 3, shortLabel: "3rd"},
    {label: "4th Grade", value: 4, shortLabel: "4th"},
    {label: "5th Grade", value: 5, shortLabel: "5th"},
    {label: "6th Grade", value: 6, shortLabel: "6th"},
  ],// TODO reformat how seasons are consumed in admin to be extensible for Southern hemisphere
  seasons: ["Fall","Winter","Spring"],
}